import {ref} from 'vue'

//Global flag
const isCatchAll = ref(false)

/**
 * Simple catch all check to see if we're on the catch all route
 */
export function useCatchAllCheck() {

  //Set the catch all flag
  const setCatchAll = () => isCatchAll.value = true
  const clearCatchAll = () => isCatchAll.value = false

  //Expose interface
  return {
    isCatchAll,
    setCatchAll,
    clearCatchAll,
  }
}
